import { useEffect, useState } from "react";
import { policies$ } from "services/subjects/policies";
import { EnrollmentPoliciesResponse } from "types/dtos/responses/EnrollmentPoliciesResponse";

export type UsePoliciesReturn = {
    loadingPoliciesData: boolean;
} & {
    [key in keyof EnrollmentPoliciesResponse]?: EnrollmentPoliciesResponse[key];
};

export const usePoliciesData = (): UsePoliciesReturn => {
    const [policiesResponse, setPoliciesResponse] = useState<EnrollmentPoliciesResponse | null>(null);
    const [loadingPolicies, setLoadingPolicies] = useState(true);
    useEffect(() => {
        setLoadingPolicies(true);
        const subscription = policies$.subscribe((policies) => {
            setPoliciesResponse(policies);
        });
        return () => subscription.unsubscribe();
    }, []);

    return {
        loadingPoliciesData: loadingPolicies,
        ...policiesResponse
    }
};